<template>
  <v-card
    class="mx-auto"
    max-width="400"
    tile
  >
    <v-card-title>Länkar</v-card-title>    
    <v-card-text>
      <v-list>      
        <v-list-item-group          
          color="primary"
        >
          <v-list-item
            v-for="(item, i) in shortcuts"
            :key="i"
          >          
            <v-list-item-title @click="openInNewTab(item.url)" v-text="item.name" />
            <v-list-item-action @click="removeItem(item)">
              <v-icon                  
                color="grey lighten-1"
              >
                mdi-trash-can
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
        <v-divider />
        <v-list-item>
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header>
                Lägg till länk
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form ref="form"                                    
                        v-model="valid"
                        lazy-validation
                >
                  <v-text-field
                    v-model="name"
                    label="Titel"
                    :rules="[rules.req]"
                    required
                  />

                  <v-text-field
                    v-model="url"                            
                    label="Länk"
                    :rules="[rules.url]"
                    required
                  />
                  <v-btn
                    color="success"
                    class="mr-4"
                    @click="addShortcut()"
                  >
                    Lägg till
                  </v-btn>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>              
          </v-expansion-panels>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from 'lodash'
import adminApi from '@/backend/adminapi'
import log from '@/logger'
export default{
    name:'Shortcuts',
    data(){
        return{
            shortcuts:[],
                name:'',
                url:'',
                panel: true,
                drawer: null,
                valid: true,
                rules: {
    req: value => !!value || 'Required.',
    url: value => {
      const regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}/gm
      return regex.test(value) || 'Invalid Url Format!!'
   },
},
        }
    },    
    mounted(){
        adminApi.adminGetShortcuts()
        .then((resp)=>{
            this.shortcuts = resp.data
        })
        .catch((error) => {
            log.debug('Error getting shortcuts:', error)
        })
    },
    methods: {
        openInNewTab(url) {
            window.open(url, '_blank', 'noreferrer')
        },
        removeItem (shortcut) {
            adminApi.adminDeleteShortcut(shortcut.id)
            .then((resp)=>{
                log.debug('Shortcut deleted:', resp.data)

                this.shortcuts = _.reject(this.shortcuts, function(item) {return (item.id === shortcut.id)})
            })
            .catch((error) => {
                log.debug('Error getting shortcuts:', error)
            })          
        } ,
        addShortcut(){
            if( this.$refs.form.validate()){
                const formData = new FormData()
                formData.append('name', this.name)
                formData.append('url', this.url)
                adminApi.adminSaveShortcut(formData)
                .then((resp) => {
                    log.debug('Shortcut saved:', resp.data)
                    this.shortcuts.push(resp.data)               
                    this.name = ''
                    this.url = ''
                    this.panel = false
                })
                .catch((error) => {          
                    log.debug('Error saving shortcut:', error)
                })
                
            }
        }
  },
}
</script>

<style scoped>
</style>